import { FC, PropsWithChildren, useLayoutEffect } from 'react';

import { adminApiWrapper } from '@/shared/api/admin';

import { useAdminLogout } from '@/features/admin-auth';

import { setupStore } from '@/app/store/store';

/**
 * Обертка для добавления admin auth headers в запросы `/api/admin/v1`
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const AdminApiInterceptions: FC<PropsWithChildren> = ({ children }) => {
  const logout = useAdminLogout();

  useLayoutEffect(() => {
    adminApiWrapper.addMonitor(response => {
      if (!response.ok && response.status === 401) {
        logout(true);
      }
    });

    adminApiWrapper.addRequestTransform(request => {
      const { auth } = setupStore.getState().adminSession;

      if (auth) {
        request.headers = { ...request.headers, ...auth };
      }
    });
  }, []);

  return children;
};
